var _path, _path2, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationRed = function SvgLocationRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M52.573 29.11c0-9.315-7.133-16.892-15.903-16.892s-15.904 7.577-15.904 16.896c.003.465.224 11.609 12.962 31.245a3.463 3.463 0 0 0 2.817 1.934c1.84 0 3.094-2.026 3.216-2.232C52.58 40.413 52.58 29.553 52.573 29.11ZM36.67 35.913a7.083 7.083 0 1 1 7.083-7.082 7.09 7.09 0 0 1-7.083 7.082Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5a47",
    d: "M52.573 29.11c0-9.315-7.133-16.892-15.903-16.892a14.96 14.96 0 0 0-3.865.525c8.395.45 15.1 7.823 15.1 16.85.006.443.006 11.303-12.813 30.95a5.854 5.854 0 0 1-.586.797 2.855 2.855 0 0 0 2.04.954c1.839 0 3.093-2.027 3.215-2.233C52.58 40.413 52.58 29.553 52.573 29.11Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.545 62.294a3.463 3.463 0 0 1-2.817-1.935C20.99 40.723 20.769 29.58 20.766 29.114c0-9.32 7.134-16.896 15.904-16.896s15.903 7.577 15.903 16.892c.007.444.007 11.304-12.812 30.95-.122.207-1.377 2.233-3.216 2.233Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.67 35.913a7.083 7.083 0 1 1 7.083-7.082 7.09 7.09 0 0 1-7.083 7.082Z"
  }))));
};
export default SvgLocationRed;